<template>
  <nav aria-label="Sidebar" class="md:block md:flex-shrink-0 md:bg-gray-800 md:overflow-y-auto">
    <div class="relative flex flex-col space-y-3">
      <template v-for="(item, key) in navigation" :key="key">
        <router-link
          :to="item.path || ''"
          class="flex-shrink-0 p-2 inline-flex items-center justify-start rounded-lg text-gray-700 text-sm"
          exact
          exact-active-class="bg-gray-100"
        >
          <span class="rounded-md">{{ item.name }}</span>
        </router-link>
      </template>
    </div>
  </nav>
</template>

<script lang="ts">
import { computed, defineComponent, inject } from 'vue'
import { useRouter } from 'vue-router'
import type { RouteRecordNormalized } from 'vue-router'
import { useStore } from 'vuex'
import { ABILITY_TOKEN } from '@casl/vue'
import { Ability } from '@casl/ability'

type NavigationItem = {
  name: string
  icon?: string
  path?: string
}

export default defineComponent({
  name: 'SidebarMobile',
  setup() {
    const store = useStore()
    const router = useRouter()
    const ability = inject<Ability>(ABILITY_TOKEN)
    const authRole = computed(() => store.getters['user/authRole'])

    const routes = router.getRoutes().reduce((carry: RouteRecordNormalized[], route) => {
      if (route.meta.requiresAuth) {
        carry.push(route)
      }
      return carry
    }, [])

    const navigation = computed(() =>
      routes
        .filter((route) => !route.meta.hideInMenu)
        .reduce((carry: NavigationItem[], route) => {
          const navItem: NavigationItem = {
            name: route.name as string,
            path: route.path,
          }

          if (!route.meta.roles || (route.meta.roles as string[]).length === 0) {
            carry.push(navItem)
            return carry
          }

          if (
            Array.isArray(route.meta.roles) &&
            route.meta.roles.length &&
            route.meta.roles.includes(authRole.value)
          ) {
            if (Array.isArray(route.meta.abilities) && route.meta.abilities.length) {
              if (route.meta.abilities.some((p) => ability?.can(p.action, p.name))) {
                carry.push(navItem)
              }
              return carry
            }
            carry.push(navItem)
          }
          return carry
        }, []),
    )

    return {
      navigation,
    }
  },
})
</script>
